import { render, staticRenderFns } from "./ReportingUnitCount.vue?vue&type=template&id=58fc8f52&scoped=true"
import script from "./ReportingUnitCount.vue?vue&type=script&lang=js"
export * from "./ReportingUnitCount.vue?vue&type=script&lang=js"
import style0 from "./ReportingUnitCount.vue?vue&type=style&index=0&id=58fc8f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc8f52",
  null
  
)

export default component.exports